import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import PCContainer from "../../components/atoms/layout/pcContainer";

import useDisplay from "../../hooks/useDisplay";
import { route } from "../../router/route";

import LSRgH1HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdH2HeadLine from "../../components/molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSRgH2HeadLine from "../../components/molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import LSBdBody01 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody01";
import LSRgCaption02 from "../../components/molecules/text/linSeedKr/Rg/lsRgCaption02";
import LSBdDisplay02 from "../../components/molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgBody01 from "../../components/molecules/text/linSeedKr/Rg/lsRgBody01";
import MainBtn from "../../components/atoms/button/mainBtn";
import LSBdBody02 from "../../components/molecules/text/linSeedKr/Bd/lsBdBody02";
import TextArea from "../../components/atoms/input/textarea";
import ColumnApi from "../../api/column.api";
import { errorHandler } from "../../util/errorHandler";
import moment from "moment";
import {
  formatNumberKM,
  formatNumberWithCommas,
} from "../../util/formatNumber";
import { toast } from "react-toastify";
import { fileUrl } from "../../api/api";
import ReportModal from "../../components/templates/modals/reportModal";
import CommunityApi from "../../api/community.api";
import { macOSCheck } from "../../util/macOSCheck";
import ConfirmModal from "../../components/templates/modals/confirmModal";
import Loading from "../../components/templates/loading";

const ColumnDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const requestedCategoryValue = Number(location.state?.categoryValue);
  const categoryValue =
    Number.isInteger(requestedCategoryValue) && requestedCategoryValue > 0
      ? requestedCategoryValue
      : -1;

  const { isMobile, isTablet, isDesktop } = useDisplay();

  const navigate = useNavigate();
  const [comments, setComments] = useState("");
  const [columnInfo, setColumnInfo] = useState(null);
  const [isScrap, setIsScrap] = useState(false);
  const [scrapCount, setScrapCount] = useState(0);

  const [commentList, setCommentList] = useState([]);
  const [isReportModal, setIsReportModal] = useState(false);
  const [nextColumnInfo, setNextColumnInfo] = useState();
  const [preColumnInfo, setPreColumnInfo] = useState();

  const [commentReportId, setCommentReportId] = useState(0);
  const [commentDelId, setCommentDelId] = useState(0);
  const [commentEditId, setCommentEditId] = useState(0);
  const [editComments, setEditComments] = useState("");
  const [isCommentDelModal, setIsCommentDelModal] = useState(false);
  const [isScrapProcessing, setIsScrapProcessing] = useState(false);
  const [isCommentProcessing, setIsCommentProcessing] = useState(false);
  const [isReportProcessing, setIsReportProcessing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const columnId = Number(id);
    if (!Number.isInteger(columnId) || columnId <= 0) {
      toast("잘못된 칼럼 주소입니다.");
      navigate(route.column_list, { replace: true });
      return;
    }

    setColumnInfo(null);
    setCommentList([]);
    setPreColumnInfo();
    setNextColumnInfo();
    getColumnInfo();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (columnInfo?.id) {
      getNextPreColumnInfo();
    }
  }, [columnInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  const getNextPreColumnInfo = async () => {
    try {
      const data = {
        page: 1,
        size: 1,
        cursor: columnInfo.id,
        sort: "id",
        orderBy: "DESC",
        activation: "Active",
      };

      if (categoryValue > 0) {
        data.columnCategoryId = categoryValue;
      }

      const response = (await ColumnApi.getList(data)).data.data.content;

      if (response && response.length > 0) {
        setPreColumnInfo(response[0]);
      } else {
        setPreColumnInfo();
      }

      const data02 = {
        page: 1,
        size: 1,
        cursor: columnInfo.id,
        sort: "id",
        orderBy: "ASC",
        activation: "Active",
      };

      if (categoryValue > 0) {
        data02.columnCategoryId = categoryValue;
      }

      const response02 = (await ColumnApi.getList(data02)).data.data.content;

      if (response02 && response02.length > 0) {
        setNextColumnInfo(response02[0]);
      } else {
        setNextColumnInfo();
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  const getColumnInfo = async () => {
    setIsLoading(true);
    try {
      const response = (await ColumnApi.getDetail(id)).data.data.content;

      setColumnInfo(response);
      setIsScrap(Boolean(response.isScrap));
      setScrapCount(Number(response.scrapCount) || 0);

      await getCommmentList(response.id);
    } catch (error) {
      errorHandler(error);
      navigate(route.column_list, { replace: true });
    } finally {
      setIsLoading(false);
    }
  };

  const getCommmentList = async (id) => {
    try {
      const data = {
        page: 1,
        size: 0,
        columnPostId: id ? id : columnInfo.id,
      };
      const response = (await ColumnApi.commentList(data)).data.data.content;

      setCommentList(response ?? []);
    } catch (error) {
      errorHandler(error);
    }
  };

  const scrapFunc = async () => {
    if (isScrapProcessing || !columnInfo?.id) return;
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("스크랩하려면 로그인을 해주세요.");
      navigate(route.login, { state: { path: window.location.href } });
      return;
    }

    setIsScrapProcessing(true);
    try {
      const requestData = {
        columnPostId: columnInfo.id,
      };

      await ColumnApi.putScrap(requestData);

      setIsScrap((prev) => !prev);
      setScrapCount((prev) => Math.max(0, prev + (isScrap ? -1 : 1)));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsScrapProcessing(false);
    }
  };

  const handleCopyClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);

      toast("주소가 복사되었습니다.");
    } catch (error) {
      toast("주소를 복사하지 못했습니다.");
    }
  };

  const addCommmentList = async () => {
    const content = comments.trim();
    if (isCommentProcessing || !content || !columnInfo?.id) return;
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("댓글을 등록하려면 로그인을 해주세요.");
      navigate(route.login, { state: { path: window.location.href } });
      return;
    }

    setIsCommentProcessing(true);
    try {
      const data = {
        columnPostId: columnInfo.id,
        content,
      };
      await ColumnApi.registerComment(data);

      setComments("");
      await getCommmentList();

      toast("댓글이 등록되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsCommentProcessing(false);
    }
  };

  const reportFunc = async (value) => {
    if (isReportProcessing) return;
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("신고하려면 로그인을 해주세요.");
      navigate(route.login, { state: { path: window.location.href } });
      return;
    }

    setIsReportProcessing(true);
    try {
      const data =
        commentReportId === 0
          ? {
              columnPostId: columnInfo.id,
              reason: value,
              postFlag: true,
            }
          : {
              postCommentId: commentReportId,
              reason: value,
              postFlag: false,
            };

      await CommunityApi.report(data);

      setCommentReportId(0);
      toast("신고되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsReportModal(false);
      setIsReportProcessing(false);
    }
  };

  const deleteCommentFunc = async () => {
    if (isCommentProcessing || !commentDelId) return;
    setIsCommentProcessing(true);
    try {
      const data = {
        ids: [commentDelId],
        allFlag: false,
      };
      await ColumnApi.delComment(data);

      setCommentDelId(0);
      await getCommmentList();

      toast("댓글이 삭제되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsCommentProcessing(false);
    }
  };

  const editCommmentList = async () => {
    const content = editComments.trim();
    if (isCommentProcessing || !commentEditId || !content) return;
    setIsCommentProcessing(true);
    try {
      const data = {
        content,
      };

      await ColumnApi.editComment(commentEditId, data);

      setEditComments("");
      setCommentEditId(0);
      await getCommmentList();

      toast("댓글이 수정되었습니다.");
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsCommentProcessing(false);
    }
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <ColumnDetailSection>
        <PCContainer
          style={{
            flexDirection: "column",
            padding: isMobile
              ? "40px 20px 80px 20px"
              : isTablet
                ? "40px 60px 80px 60px"
                : "80px 0px 161px 0px",
            width: "100%",
          }}
        >
          <div
            onClick={() => {
              navigate(-1);
            }}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              cursor: "pointer",
              marginBottom: 20,
            }}
          >
            <img
              src="/assets/icons/left_text.svg"
              alt="left_text"
              style={{
                width: isMobile ? 6 : 8,
                height: isMobile ? 12 : 14,
              }}
            />

            <LSRgH1HeadLine
              style={{
                color: "#101113",
                marginTop: 2,
                marginLeft: isMobile ? 6 : 10,
                fontSize: isMobile ? 10 : 16,
                lineHeight: isMobile ? "12px" : "22.4px",
              }}
            >
              뒤로가기
            </LSRgH1HeadLine>
          </div>

          <WhiteBoxContain $isMobile={isMobile}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: isMobile ? 10 : 24,
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    border: "1px solid #5050FF",
                    borderRadius: 30,
                    padding: "4px 14px",
                    alignSelf: "flex-start",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: isMobile ? 0 : 10,
                  }}
                >
                  <LSBdBody01
                    style={{
                      color: "#5050FF",
                      marginTop: macOSCheck() ? 0 : 2,
                    }}
                  >
                    {columnInfo?.columnCategory?.title}
                  </LSBdBody01>
                </div>
                {isMobile ? null : (
                  <LSBdDisplay02
                    style={{
                      color: "#000000",
                      fontSize: isMobile ? 18 : 24,
                      lineHeight: isMobile ? "25.2px" : "33.6px",
                    }}
                  >
                    {columnInfo?.title}
                  </LSBdDisplay02>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginRight: 7,
                  cursor: "pointer",
                }}
                onClick={() => {
                  scrapFunc();
                }}
                aria-disabled={isScrapProcessing}
              >
                <img
                  style={{
                    height: isMobile ? 32 : 42,
                    width: isMobile ? 32 : 42,
                    marginBottom: isMobile ? 0 : 8,
                  }}
                  src={
                    isScrap
                      ? "/assets/icons/bookmark_a.png"
                      : "/assets/icons/bookmark_d.png"
                  }
                  alt="bookmark_a"
                />

                {isMobile ? null : (
                  <LSRgH1HeadLine
                    style={{
                      color: "#101113",
                      fontSize: isMobile ? 10 : 16,
                      lineHeight: isMobile ? "12px" : "22.4px",
                    }}
                  >
                    {formatNumberWithCommas(scrapCount)}
                  </LSRgH1HeadLine>
                )}
              </div>
            </div>

            {isMobile ? (
              <LSBdDisplay02
                style={{
                  color: "#000000",
                  fontSize: isMobile ? 18 : 24,
                  lineHeight: isMobile ? "25.2px" : "33.6px",
                  marginBottom: 24,
                }}
              >
                {columnInfo?.title}
              </LSBdDisplay02>
            ) : null}

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: isMobile ? "12px 0px" : "16px 0px",
                borderTop: "1px solid #DBDDE0",
                borderBottom: "1px solid #DBDDE0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <LSRgCaption02
                    style={{
                      color: "#000000",
                      marginRight: 24,
                      fontSize: isMobile ? 10 : 12,
                      lineHeight: isMobile ? "12px" : "14.4px",
                    }}
                  >
                    {moment(columnInfo?.createdAt).format("YYYY.MM.DD")}
                  </LSRgCaption02>
                  <img
                    style={{
                      height: isMobile ? 14 : 18,
                      width: isMobile ? 14 : 18,
                      marginRight: 6,
                    }}
                    src="/assets/icons/carbon_view.png"
                    alt="carbon_view"
                  />
                  <LSRgCaption02
                    style={{
                      color: "#000000",
                      fontSize: isMobile ? 10 : 12,
                      lineHeight: isMobile ? "12px" : "14.4px",
                    }}
                  >
                    {formatNumberKM(
                      columnInfo?.viewCount ? columnInfo?.viewCount : 0,
                    )}
                  </LSRgCaption02>
                </div>
              </div>
            </div>

            <LSRgH1HeadLine
              className="ql-editor"
              style={{
                color: "#000000",
                fontSize: isMobile ? 14 : 16,
                lineHeight: isMobile ? "19.6px" : "22.4px",
                marginTop: isMobile ? 20 : 30,
              }}
              dangerouslySetInnerHTML={{
                __html: columnInfo?.content,
              }}
            />

            <div
              onClick={() => {
                handleCopyClipBoard();
              }}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                cursor: "pointer",
                marginTop: isMobile ? 20 : 30,
              }}
            >
              <img
                style={{
                  height: isMobile ? 16 : 24,
                  width: isMobile ? 16 : 24,
                }}
                src="/assets/icons/share.png"
                alt="share"
              />

              <LSRgH1HeadLine
                style={{
                  color: "#A4A8B1",
                  marginLeft: 10,
                  fontSize: isMobile ? 12 : 16,
                  lineHeight: isMobile ? "14.4px" : "22.4px",
                }}
              >
                공유
              </LSRgH1HeadLine>
            </div>
          </WhiteBoxContain>

          <WhiteBoxContain
            $isMobile={isMobile}
            style={{
              marginTop: isMobile ? 20 : 40,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
                paddingBottom: isMobile ? 12 : 16,
                borderBottom: "1px solid #DBDDE0",
              }}
            >
              <LSBdH2HeadLine
                style={{
                  color: "#101113",
                  fontSize: isMobile ? 15 : 18,
                  lineHeight: isMobile ? "21px" : "25.2px",
                  marginRight: isMobile ? 8 : 6,
                }}
              >
                댓글
              </LSBdH2HeadLine>
              <LSBdH2HeadLine
                style={{
                  color: "#5050FF",
                  fontSize: isMobile ? 15 : 18,
                  lineHeight: isMobile ? "21px" : "25.2px",
                }}
              >
                {formatNumberWithCommas(commentList.length)}
              </LSBdH2HeadLine>
            </div>

            {commentList.map((item) => {
              return (
                <div
                  key={item.id}
                  style={{
                    marginTop: isMobile ? 20 : 30,
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <img
                    style={{
                      height: isMobile ? 30 : 50,
                      width: isMobile ? 30 : 50,
                      marginRight: isMobile ? 20 : 30,
                      borderRadius: 999,
                    }}
                    src={
                      item.member?.profileServerFileName
                        ? `${fileUrl}/${item.member.profileServerFileName}`
                        : "/assets/icons/profile.png"
                    }
                    alt="profile"
                  />
                  {commentEditId === item.id ? (
                    <div
                      style={{
                        background: "#F6F7F880",
                        width: "100%",
                        borderRadius: 15,
                        padding: isMobile ? "10px" : "20px 30px 56px 30px",
                        position: "relative",
                      }}
                    >
                      <LSBdH2HeadLine
                        style={{
                          color: "#000000",
                          marginBottom: isMobile ? 7 : 15,
                          fontSize: isMobile ? 12 : 18,
                          lineHeight: isMobile ? "16.8px" : "25.2px",
                        }}
                      >
                        {sessionStorage.getItem("nickname")}
                      </LSBdH2HeadLine>

                      <TextArea
                        placeholder="댓글을 입력해 보세요."
                        value={editComments}
                        onChange={(e) => {
                          setEditComments(e.target.value);
                        }}
                        style={{
                          background: "#F6F7F880",
                          border: "none",
                          height: 110,
                        }}
                      />

                      <MainBtn
                        disabled={isCommentProcessing || !editComments.trim()}
                        onClick={() => {
                          editCommmentList();
                        }}
                        style={{
                          width: 60,
                          height: isMobile ? 28 : 32,
                          borderRadius: 8,
                          position: "absolute",
                          bottom: 20,
                          right: 20,
                        }}
                      >
                        <LSBdBody02
                          style={{
                            color: "#FFFFFF",
                            textAlign: "center",
                            fontSize: isMobile ? 12 : 15,
                            lineHeight: isMobile ? "16.8px" : "21px",
                          }}
                        >
                          수정
                        </LSBdBody02>
                      </MainBtn>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "84%",
                      }}
                    >
                      <LSBdH2HeadLine
                        style={{
                          color: "#000000",
                          margin: isMobile ? "0px" : "12px 0px",
                          fontSize: isMobile ? 12 : 18,
                          lineHeight: isMobile ? "14.4px" : "25.2px",
                        }}
                      >
                        {item.member?.nickname ?? "회원"}
                      </LSBdH2HeadLine>

                      <LSRgH1HeadLine
                        style={{
                          color: "#000000",
                          margin: "8px 0px",
                          fontSize: isMobile ? 12 : 16,
                          lineHeight: isMobile ? "14.4px" : "22.4px",
                          wordWrap: "break-word" /* 단어를 자를 수 있게 설정 */,
                          overflowWrap:
                            "break-word" /* 단어가 넘칠 경우 줄바꿈 */,
                          whiteSpace:
                            "pre-wrap" /* 공백도 유지하고 자동 줄바꿈 허용 */,
                        }}
                      >
                        {item.content}
                      </LSRgH1HeadLine>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <LSRgBody01
                          style={{
                            color: "#A4A8B1",
                            marginRight: 20,
                            fontSize: isMobile ? 10 : 14,
                            lineHeight: isMobile ? "12px" : "19.6px",
                            width: isMobile ? "100%" : "auto",
                            marginTop: macOSCheck() ? 0 : 4,
                          }}
                        >
                          {moment(item.createdAt).format("YYYY.MM.DD HH:mm")}
                        </LSRgBody01>

                        {item?.member?.id ===
                        Number(sessionStorage.getItem("id")) ? (
                          <>
                            <LSRgBody01
                              onClick={() => {
                                setCommentEditId(item.id);
                                setEditComments(item.content);
                              }}
                              style={{
                                color: "#A4A8B1",
                                cursor: "pointer",
                                fontSize: isMobile ? 10 : 14,
                                lineHeight: isMobile ? "12px" : "19.6px",
                              }}
                            >
                              수정
                            </LSRgBody01>
                            <LSRgBody01
                              onClick={() => {
                                setIsCommentDelModal(true);
                                setCommentDelId(item.id);
                              }}
                              style={{
                                color: "#A4A8B1",
                                marginLeft: 12,
                                cursor: "pointer",
                                fontSize: isMobile ? 10 : 14,
                                lineHeight: isMobile ? "12px" : "19.6px",
                              }}
                            >
                              삭제
                            </LSRgBody01>
                          </>
                        ) : (
                          <>
                            <img
                              onClick={() => {
                                setCommentReportId(item.id);
                                setIsReportModal(true);
                              }}
                              style={{
                                height: isMobile ? 12 : 16,
                                width: isMobile ? 12 : 16,
                                cursor: "pointer",
                              }}
                              src="/assets/icons/report.png"
                              alt="report"
                            />
                            <LSRgBody01
                              onClick={() => {
                                setIsReportModal(true);
                                setCommentReportId(item.id);
                              }}
                              style={{
                                color: "#A4A8B1",
                                marginLeft: isMobile ? 5 : 10,
                                cursor: "pointer",
                                marginTop: macOSCheck() ? 0 : 4,
                                fontSize: isMobile ? 10 : 14,
                                lineHeight: isMobile ? "12px" : "19.6px",
                              }}
                            >
                              신고
                            </LSRgBody01>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            <div
              style={{
                marginTop: isMobile ? 20 : 30,
                background: "#F6F7F880",
                width: "100%",
                borderRadius: 15,
                padding: isMobile ? "10px" : "20px 30px 56px 30px",
                position: "relative",
              }}
            >
              <LSBdH2HeadLine
                style={{
                  color: "#000000",
                  marginBottom: isMobile ? 7 : 15,
                  fontSize: isMobile ? 12 : 18,
                  lineHeight: isMobile ? "16.8px" : "25.2px",
                }}
              >
                {sessionStorage.getItem("nickname")}
              </LSBdH2HeadLine>

              <TextArea
                placeholder="댓글을 입력해 보세요."
                value={comments}
                onChange={(e) => {
                  setComments(e.target.value);
                }}
                style={{
                  background: "#F6F7F880",
                  border: "none",
                  height: 110,
                }}
              />

              <MainBtn
                disabled={isCommentProcessing || !comments.trim()}
                onClick={() => {
                  addCommmentList();
                }}
                style={{
                  width: 60,
                  height: isMobile ? 28 : 32,
                  borderRadius: 8,
                  position: "absolute",
                  bottom: 20,
                  right: 20,
                }}
              >
                <LSBdBody02
                  style={{
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontSize: isMobile ? 12 : 15,
                    lineHeight: isMobile ? "16.8px" : "21px",
                  }}
                >
                  {isCommentProcessing ? "처리 중" : "등록"}
                </LSBdBody02>
              </MainBtn>
            </div>
          </WhiteBoxContain>

          <div
            style={{
              marginTop: 40,
            }}
          >
            {preColumnInfo ? (
              <div
                onClick={() => {
                  if (categoryValue > 0) {
                    navigate(`${route.column_detail}/${preColumnInfo.id}`, {
                      state: { categoryValue: categoryValue },
                    });
                  } else {
                    navigate(`${route.column_detail}/${preColumnInfo.id}`);
                  }
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: isMobile ? "20px 10px" : "20px 10px 20px 30px",
                  borderTop: "1px solid #DBDDE0",
                  borderBottom: "1px solid #DBDDE0",
                  cursor: "pointer",
                }}
              >
                <LSBdH2HeadLine
                  style={{
                    color: "#A4A8B1",
                    marginRight: isMobile ? 15 : 40,
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  이전글
                </LSBdH2HeadLine>
                <ContentTitle
                  style={{
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  {preColumnInfo.title}
                </ContentTitle>
              </div>
            ) : null}

            {nextColumnInfo ? (
              <div
                onClick={() => {
                  if (categoryValue > 0) {
                    navigate(`${route.column_detail}/${nextColumnInfo.id}`, {
                      state: { categoryValue: categoryValue },
                    });
                  } else {
                    navigate(`${route.column_detail}/${nextColumnInfo.id}`);
                  }
                }}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: isMobile ? "20px 10px" : "20px 10px 20px 30px",
                  borderTop: preColumnInfo ? "none" : "1px solid #DBDDE0",
                  borderBottom: "1px solid #DBDDE0",
                  cursor: "pointer",
                }}
              >
                <LSBdH2HeadLine
                  style={{
                    color: "#A4A8B1",
                    marginRight: isMobile ? 15 : 40,
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  다음글
                </LSBdH2HeadLine>
                <ContentTitle
                  style={{
                    fontSize: isMobile ? 12 : 18,
                    lineHeight: isMobile ? "14.4px" : "25.2px",
                  }}
                >
                  {nextColumnInfo?.title}
                </ContentTitle>
              </div>
            ) : null}
          </div>
        </PCContainer>
      </ColumnDetailSection>

      {isCommentDelModal ? (
        <ConfirmModal
          isScroll={false}
          title={"댓글을 삭제하시겠습니까?"}
          onClick={() => {
            setIsCommentDelModal(false);
          }}
          onYClick={() => {
            setIsCommentDelModal(false);
            deleteCommentFunc();
          }}
        />
      ) : null}

      {isReportModal ? (
        <ReportModal
          isScroll={false}
          onClick={() => {
            setIsReportModal(false);
            setCommentReportId(0);
          }}
          onYClick={(value) => {
            reportFunc(value);
          }}
        />
      ) : null}
    </>
  );
};

export default ColumnDetail;

const ColumnDetailSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #ededff80;
`;

const WhiteBoxContain = styled.div`
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px 0px;
  padding: ${(props) => (props.$isMobile ? "30px 20px" : "40px")};
  width: 100%;
  border-radius: 15px;
`;

const ContentTitle = styled(LSRgH2HeadLine)`
  color: #000000;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 1; // 원하는 라인수
  -webkit-box-orient: vertical;
`;
